import _ from 'lodash';
import {connect} from 'react-redux';

import {createShallowEqualSelector, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {makeGetVisibleBannersForPanel} from '../../../../store/panels/app/banners/bannersSelectors';
import {BannerTypesEnum} from '../../../../store/panels/app/banners/bannersState';
import {AppPanelId} from '../../../../store/panels/panelStateBase';
import {ErrorBanners} from './errorBanners';

/*
 * Props.
 */

interface ErrorBannersContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

function makeGetSortedErrorBanners() {
  return createShallowEqualSelector(makeGetVisibleBannersForPanel(), (visibleBanners) =>
    _(visibleBanners)
      .map((b) => b.type === BannerTypesEnum.ERROR && b)
      .compact()
      .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ErrorBannersContainerProps>()(() => ({
  banners: makeGetSortedErrorBanners(),
}));

export const ErrorBannersContainer = connect(mapStateToProps)(ErrorBanners);
